module.exports = __webpack_public_path__ + "img/maTouQin5.8a5cc1de.png";